//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

import { get } from 'lodash'

export const getStartDate = state => get(state, 'packageLogs.startDate')
export const getEndDate = state => get(state, 'packageLogs.endDate')
export const getPackageLogs = state => get(state, 'packageLogs') || {}
